import { WithNAFallback } from '@design/components/table';
import { getPriceStatus } from '@helpers/utils/numbers/numbers';
import { priceChangeColors } from '@terminal/utils/common/utils';

import {
  formatNumberWithUnit,
  formatPercentageNumber,
} from '../../utils/utils';
import styles from './NumberCell.module.scss';

interface NumberCellProps {
  value: number | undefined;
  percentage?: boolean;
  useFallbackDash?: boolean;
  fallbackTooltip?: string;
  includePercentSign?: boolean;
  variant?: 'directional' | 'neutral';
}

export const NumberCell = ({
  value,
  percentage,
  useFallbackDash,
  fallbackTooltip,
  includePercentSign = true,
  variant = 'directional',
}: NumberCellProps) => {
  const formattedValue = percentage
    ? formatPercentageNumber({ value, includePercentSign, addPlus: percentage })
    : formatNumberWithUnit(value);

  return (
    <span
      className={styles.numberTableValue}
      style={
        variant === 'directional'
          ? { color: priceChangeColors[getPriceStatus(value)] }
          : undefined
      }
    >
      <WithNAFallback
        containerPadding="0 0 0 8px"
        check={formattedValue !== '-'}
        value={formattedValue}
        useFallbackDash={useFallbackDash}
        tooltip={fallbackTooltip}
      />
    </span>
  );
};
